import { render, staticRenderFns } from "./doHandledb.vue?vue&type=template&id=05ac4aa8&"
import script from "./doHandledb.vue?vue&type=script&lang=js&"
export * from "./doHandledb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports